import { useState } from "react";

const faqData = [
  {
    question: "Jakie składniki zawierają żelki Evera?",
    answer: `Nasze żelki zawierają wyłącznie naturalne składniki roślinne, witaminy oraz minerały. Nie stosujemy sztucznych barwników, cukru ani GMO.`,
  },
  {
    question: "Po jakim czasie zauważę efekty stosowania?",
    answer: `Czas, po którym zauważysz efekty, może różnić się w zależności od osoby oraz celu stosowania suplementu. Wiele osób zauważa pierwsze rezultaty już po kilku dniach lub tygodniach stosowania. Warto pamiętać, że regularność w przyjmowaniu suplementów jest kluczowa, aby uzyskać najlepsze efekty.`,
  },
  {
    question: "Czy żelki Evera są odpowiednie dla wegan?",
    answer: `Tak, wszystkie nasze żelki są w 100% roślinne, bez składników pochodzenia zwierzęcego. Dodatkowo, nasze suplementy nie zawierają sztucznych dodatków, cukru, GMO ani glutenu, co czyni je idealnym wyborem dla wegan i wegetarian.`,
  },
  {
    question: "Czy produkty Evera są bezpieczne?",
    answer: `Produkty Evera są w pełni bezpieczne. Stosujemy wyłącznie składniki, których działanie zostało potwierdzone badaniami naukowymi, a cały proces produkcyjny odbywa się w certyfikowanych zakładach zgodnych z zasadami Dobrej Praktyki Wytwarzania (GMP). Dzięki temu możemy zagwarantować czystość, bezpieczeństwo i skuteczność naszych suplementów.`,
  },
];

function FAQItem({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="faq-item">
      <button
        className="flex flex-col justify-between cursor-pointer font-satoshi-medium font-[500] items-center w-full py-[24px] px-[32px] mq450:py-[32px] text-left font-palanquin text-[24px] no-underline visited:text-[#4040F2] text-[#131F42] mq450:text-[16px] mq450:leading-[150%]"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          backgroundColor: isOpen ? '#939ACB' : '#E4E6F2', // Toggle between two colors when open/closed
          borderRadius: '16px', // Rounded corners
        }}
      >
        <div className={`flex flex-row justify-between w-full font-silka-semibold font-[500] text-[18px] items-center ${isOpen ? 'text-white' : 'text-[#362F5B]'}`}>
          {question}
          {/* Conditional Rendering of SVG Icons */}
          {isOpen ? (
            <img
              src="/x-open.svg"
              alt="Toggle Open"
              className="w-[40px] h-[40px] mq450:w-[32px] mq450:h-[32px] transition-transform duration-500"
            />
          ) : (
            <img
              src="/x-closed.svg"
              alt="Toggle Closed"
              className="w-[40px] h-[40px] mq450:w-[32px] mq450:h-[32px] transition-transform duration-500"
            />
          )}
        </div>

        {/* Answer section with animation */}
        <div
          className={`faq-answer-wrapper transition-all duration-500 ease-in-out overflow-hidden ${isOpen ? 'max-h-[1000px] opacity-100 visible' : 'max-h-0 opacity-0 invisible'}`}
          style={{
            transitionProperty: 'max-height, opacity', // Animate max-height and padding
          }}
        >
          <p
            className="faq-answer font-silka-semibold font-[300] text-white text-[16px] mq450:text-[16px] leading-[150%] no-underline visited:text-black"
            dangerouslySetInnerHTML={{ __html: answer }}
          />
        </div>
      </button>
    </div>
  );
}

export default function FAQList() {
  return (
    <div className="flex flex-col w-full gap-4">
      {faqData.map((item, index) => (
        <div key={index}>
          <FAQItem question={item.question} answer={item.answer} />
        </div>
      ))}
    </div>
  );
}
